import { useRecipe } from '../context'
import { useBasketHook } from '../context/useBasket'

export const useRecipeCookingTime = (): number | null => {
  const recipe = useRecipe()
  const useBasket = useBasketHook()

  const { numPortions } = useBasket()

  if (!recipe) {
    return null
  }

  const cookingTime =
    numPortions && recipe.prepTimes ? recipe.prepTimes[`for${numPortions}`] : undefined

  return cookingTime as number
}
